(() => {
  if (window.nicvyaUtilitiesLoaded) return;
  window.nicvyaUtilitiesLoaded = true;
  const safeStorage = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch {} }
  };
  const protectActions = root => {
    const groups = root.matches?.('[data-nv-actions]') ? [root] : root.querySelectorAll?.('[data-nv-actions]') || [];
    groups.forEach(group => {
      if (group.dataset.nvProtected) return;
      group.dataset.nvProtected = 'true';
      group.addEventListener('click', event => event.stopPropagation());
    });
  };
  protectActions(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) protectActions(node); }))).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a,summary,input,select,label');
    if (!target) return;
    if (target.matches('[data-nv-message]')) {
      const chat = document.getElementById('Avada-FAQ_WidgetTrigger');
      if (chat) { event.preventDefault(); chat.click(); }
    }
    if (target.matches('[data-nv-share]')) {
      event.preventDefault();
      const url = new URL(target.dataset.url, location.origin).href;
      const title = target.dataset.title;
      if (navigator.share) {
        try { await navigator.share({ title, url }); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      const dialog = document.querySelector('[data-nv-share-dialog]');
      const input = dialog?.querySelector('[data-nv-share-url]');
      if (input) { input.value = url; dialog.showModal(); input.focus(); input.select(); }
    }
    if (target.matches('[data-nv-previous]')) {
      if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
        event.preventDefault(); history.back();
      }
    }
    if (target.matches('[data-nv-dismiss]')) {
      safeStorage.set('nicvya-referral-dismissed', '1');
      target.closest('[data-nv-referral]').hidden = true;
    }
    if (target.matches('[data-nv-open-referral]')) {
      document.getElementById('sj_l_widget_button')?.click();
      target.closest('[data-nv-referral]').hidden = true;
    }
  }, true);
  const reminder = document.querySelector('[data-nv-referral]');
  if (!reminder || location.pathname.startsWith('/cart') || location.pathname.includes('/checkout')) return;
  let hideTimer;
  setInterval(() => {
    if (safeStorage.get('nicvya-referral-dismissed') || document.hidden || document.querySelector('dialog[open]') || !document.getElementById('sj_l_widget_button')) return;
    reminder.hidden = false;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => { reminder.hidden = true; }, 8000);
  }, 15000);
})();
